module.exports = __webpack_public_path__ + "d454dd1c9e93e2d20adcb656fe80616d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_1.jpg
 ** module id = 591
 ** module chunks = 0
 **/